import imgCopy from "assets/images/icons/copy.svg";
import copy from 'copy-to-clipboard';
import { toast } from "react-toastify";
import Maybe from "components/__new/common/Maybe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const WalletBalanceInfo = (props) => {

    const copyValue = () => {
        copy(props.value);
        toast.success("Copied: " + props.value);
    }

    return (
        <div className="flex space-x-4 justify-between">
            <div>
                {props.name}
            </div>
            <div className="text-ep-primary font-medium flex items-center text-right">
                <Maybe condition={props.loading === true}>
                    <FontAwesomeIcon icon="circle-notch" spin className="text-xl font-bold" />
                </Maybe>
                <Maybe condition={props.loading !== true}>
                    {props.value}
                    <div onClick={copyValue} className="w-5 h-5 ml-2 cursor-pointer transform transition-all hover:scale-125">
                        <img src={imgCopy} alt="Copy" className="w-full h-full object-contain" />
                    </div>
                </Maybe>
            </div>
        </div>
    )
}
